import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";

import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import FormBox from "../../component/FormBox/FormBox";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputLabel,
    makeStyles,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@material-ui/core";
import errorWarning from "../../images/icon_warning.gif";
import { isEmpty, isNotEmpty } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, setFieldValues } from "../../redux/action";
import { getFieldValues, getFormId } from "../../redux/selector";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import FileInput from "../../component/FileInput/FileInput";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export default function Confirmation() {
    const formId = useSelector(getFormId());
    const stepName = "Confirmation";

    const { t, i18n } = useTranslation();
    const classes = useStyles();

    const dispatch = useDispatch();
    let fieldValues = useSelector(getFieldValues());

    const onStepSubmit = (formData) => {
        //onStepSubmit
        console.log("onStepSubmit, formData:", formData);
        dispatch(setCurrentStep("Signature"));
    };

    const onStepError = (errors) => {
        //onStepError
        console.log("onStepError, errors: ", errors);
    };

    const onPrev = () => {
        dispatch(setCurrentStep("TableInputSample"));
    };

    return (
        <>
            {Object.entries(fieldValues).map(([stepName, stepValues]) => (
                <FormBox
                    header={t("some_translation.key", stepName)}
                    key={stepName}
                >
                    <TableContainer component={Paper}>
                        <Table
                            className={classes.table}
                            aria-label="simple table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        Dessert (100g serving)
                                    </TableCell>
                                    <TableCell align="right">
                                        Calories
                                    </TableCell>
                                    <TableCell align="right">
                                        Fat&nbsp;(g)
                                    </TableCell>
                                    <TableCell align="right">
                                        Carbs&nbsp;(g)
                                    </TableCell>
                                    <TableCell align="right">
                                        Protein&nbsp;(g)
                                    </TableCell>
                                    <TableCell align="right">Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[
                                    "frozenYoghurt",
                                    "iceCreamSandwich",
                                    "eclair",
                                    "cupcake",
                                    "gingerbread",
                                ].map((key) => {
                                    const value = stepValues?.[key];
                                    return (
                                        <TableRow key={key}>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                {t(`sample.table.${key}`)}
                                            </TableCell>

                                            <TableCell align="right">
                                                {value.calories}
                                            </TableCell>
                                            <TableCell align="right">
                                                {value.fat}
                                            </TableCell>
                                            <TableCell align="right">
                                                {value.carbs}
                                            </TableCell>
                                            <TableCell align="right">
                                                {value.protein}
                                            </TableCell>
                                            <TableCell align="right">
                                                {value.price}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </FormBox>
            ))}
            <FormBox>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="secondary"
                        className="secBtn"
                        onClick={() => onPrev()}
                    >
                        {t("common.button.back")}
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                        {t("common.button.next")}
                    </Button>
                </Box>
            </FormBox>
        </>
    );
}
